import { SearchOutlined } from '@ant-design/icons'
import { Button, Drawer } from 'antd'
import React from 'react'
import { AiOutlineCloseCircle } from 'react-icons/all'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { translate } from '../languages'
import { RootState } from '../stores'
import { setShowSearchDrawer } from '../stores/actions'

type SearchDrawerComponentProps = {
  body: React.ReactNode
  onSearch: () => void
}

export const SearchDrawerComponent: React.FC<SearchDrawerComponentProps> = ({
  body,
  onSearch,
}) => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { language } = useSelector((state: RootState) => state.language)
  const { management } = useSelector((state: RootState) => state.common)

  return (
    <Drawer
      title={
        <span>
          {translate('common.search', language) +
            ' ' +
            translate(
              `api.name.${location.pathname.replace(/\//, '')}`,
              language
            )}
        </span>
      }
      placement="left"
      closable={true}
      onClose={() => dispatch(setShowSearchDrawer(false))}
      closeIcon={<AiOutlineCloseCircle style={{ color: 'red' }} />}
      visible={management.showSearchDrawer}
      width="100%"
    >
      {body}
      <div style={{ float: 'right' }}>
        <Button
          style={{ marginTop: '20px' }}
          type="primary"
          icon={<SearchOutlined />}
          onClick={() => {
            onSearch()
            dispatch(setShowSearchDrawer(false))
          }}
        >
          {translate('common.search', language)}
        </Button>
      </div>
    </Drawer>
  )
}
